import { api } from '../../../AxiosConfig';

class BillingSettingsService {
    getPlans() {
        return api.get('/billing/plans');
    }

    getSubscription() {
        return api.get('/billing/subscription');
    }

    getPaymentMethods() {
        return api.get('/billing/payment-methods');
    }

    createPaymentMethod(data: any) {
        return api.post('/billing/payment-methods', data);
    }

    setDefaultPaymentMethod(id: string) {
        return api.post(`/billing/payment-methods/${id}/default`);
    }

    deletePaymentMethod(id: string) {
        return api.delete(`/billing/payment-methods/${id}`);
    }

    createCheckout(data: any) {
        return api.post('/billing/subscription/checkout', data);
    }

    cancelSubscription(data: any = {}) {
        return api.post('/billing/subscription/cancel', data);
    }
}

export { BillingSettingsService };
